import Api from "./Api";
import Api_2 from "./Api_extra";
import { createQueryString } from "./ApiHelper";

export default {
  GetAllRefund(payload) {
    const query = createQueryString(payload);
    return Api().get(`/api/admin/refund${query}`);
  },
  GetRefundById(payload) {
    return Api().get(`/api/admin/refund/${payload.scd_id}`);
  },
  AddRefund(payload) {
    return Api().post("/api/admin/refund", payload);
  },
  UpdateRefund(payload) {
    return Api().put(`/api/admin/refund/${payload.scd_id}`, payload);
  },
  GetTransactionRefunds(payload) {
    return Api().post(`/api/admin/getAllTransactionRefunds`, payload);
  },
  GetShowTransaction(payload) {
    return Api(payload).post(`/api/admin/getShowTransactions`, payload);
  }
};



// WEBPACK FOOTER //
// ./src/services/RefundService.js